import { createApp } from 'vue'
import App from './AppRoot.vue'
import router from './routes'
import store from './store'
import './css/style.css'
import { setStoreInstance } from './api/api-client'
import { VueGtmUseOptions, createGtm, GtmQueryParams } from '@gtm-support/vue-gtm'
import './validationRules'

// Define your GTM properties with the correct types
let gtmProperties: VueGtmUseOptions = {
  id: 'GTM-PZBMHHD',
  defer: false,
  compatibility: false,
  nonce: '2726c7f26c',
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router,
  trackOnNextTick: false,
  queryParams: import.meta.env.MODE !== 'prod' ? {} as GtmQueryParams : undefined,
}

if (import.meta.env.MODE !== 'prod') {
  gtmProperties.queryParams = {
    gtm_auth: import.meta.env.VITE_GTM_AUTH,
    gtm_preview: import.meta.env.VITE_GTM_PREVIEW,
    gtm_cookies_win: import.meta.env.VITE_GTM_COOKIES,
  }
}

// Set the store instance for the API client interceptor
setStoreInstance(store)

const app = createApp(App)
  .use(router)
  .use(store)
  .use(createGtm(gtmProperties))

if (window.dataLayer) {
  window.dataLayer.push({
    event: 'editorialOfficeSelectionMode',
    editorialOfficeSelectionMode: 'RSC',
  })
}

app.mount('#app')
